export default __webpack_public_path__ + "static/pandanoticias_landing-7681496a90211ed16c118983dd3e816e.png";